<template>
  <a-modal
    title="报名信息"
    :width="600"
    :dialog-style="{ top: '20px' }"
    :maskClosable="false"
    :keyboard="false"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :footer="null"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form" :label-col="_isMobile()?{}:{span:8}" :wrapper-col="_isMobile()?{}:{span:12}" :layout="_isMobile()?'vertical':'horizontal'">
    <!-- 默认项目 -->
      <a-form-item label="选择项目">
        <!-- :disabled="!eventInfo.eventCategory || eventCategory != ''" -->
        <j-category-select
          :disabled="applyConfig.canEditCatagory!=1"
          v-decorator="['eventCategory', validatorRules.eventCategory]"
          :mutex="true"
          :dropdownStyle=" { maxHeight: '300px', overflow: 'auto' }"
          :pid="eventInfo.eventCategory"
          :onlyLeaf="true"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          :multiple="canApplyMulti && eventInfo.applyMulti==1"
          :treeCheckable="canApplyMulti && eventInfo.applyMulti == 1"
          @change="onEventCategoryChange"
          placeholder="请选择项目"
        />
      </a-form-item>
      <a-form-item label="赛项确认" v-if="model.eventCategory">
        <span>您选择了<span style="color:red">{{model.eventCategory.split(',').length}}</span>个赛项，报名费用<span style="color:red">{{applyPrice}}</span>元。</span>
      </a-form-item>
      <a-form-item label="证件照" v-if="applyConfig.photo>0">
            <div class="ant-upload-preview" @click="$refs.photoModal.edit(1)">
              <a-icon type="cloud-upload-o" class="upload-icon" />
              <div class="mask">
                <a-icon type="plus" />
              </div>
              <img v-if="applyEventInfo.photo_url" :src="applyEventInfo.photo_url" />
            </div>
          <a-divider></a-divider>
          <p style="line-height:1.3em;color: red;">请核对照片是否为1寸蓝底免冠照片，不符合要求请重新提交，照片直接印制在证书上，请谨慎核验提交</p>
      </a-form-item>
      <a-form-item label="姓名">
        <a-input disabled v-decorator="['realname']"></a-input>
      </a-form-item>
      
      <a-form-item label="身份证号码">
        <a-input disabled v-decorator="['idcard']" placeholder="身份证/护照/台胞证"></a-input>
      </a-form-item>
      <!-- <a-form-item label="出生年月">
        <a-date-picker
          style="width: 100%"
          placeholder="请选择生日"
          v-decorator="[
            'birthday',
        0    validatorRules.birthday,
            { initialValue: null },
          ]"
          :getCalendarContainer="(node) => node.parentNode"
        />
      </a-form-item>
      <a-form-item label="性别">
        <a-radio-group v-decorator="['sex', validatorRules.sex]">
          <a-radio-button :value="1"> 男 </a-radio-button>
          <a-radio-button :value="2"> 女 </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="年级">
        <j-dict-select-tag
          v-decorator="['grade', validatorRules.grade]"
          :trigger-change="true"
          dictCode="grade"
          placeholder="请选择年级"
        />
      </a-form-item>
      <a-form-item label="邮箱">
        <a-input
          v-decorator="['email', validatorRules.email]"
        ></a-input>
      </a-form-item> -->
      <a-form-item label="辅导老师">
        <a-input
          v-decorator="['teacherName', validatorRules.teacherName]"
        ></a-input>
      </a-form-item>
      <a-form-item label="老师电话">
        <a-input
          v-decorator="['teacherPhone', validatorRules.teacherPhone]"
        ></a-input>
      </a-form-item>
      <!-- <a-form-item label="监护人">
        <a-input
          v-decorator="['parentName', validatorRules.parentName]"
        ></a-input>
      </a-form-item>
      <a-form-item label="监护人电话">
        <a-input
          v-decorator="['parentPhone', validatorRules.parentPhone]"
        ></a-input>
      </a-form-item> -->

      
      <a-form-item label="学校/机构">
        <j-search-select-tag
          v-if="checkNumber(applyEventInfo.school)"
          placeholder="请选择学校/机构"
          :async="true"
         v-model="applyEventInfo.school"
          disabled
          dict="teaching_agent,agent_name,id">
        </j-search-select-tag>
        <a-input v-else disabled v-model="applyEventInfo.school"></a-input>
      </a-form-item>
      <a-form-item label="所在地区">
        <j-area-linkage
          type="cascader"
          v-decorator="['address', validatorRules.address]"
          placeholder="请输入省市区"
        />
      </a-form-item>
      <!-- <a-form-item label="快递证书地址">
        <a-input
          v-decorator="['addressDetailed', validatorRules.addressDetailed]"
          placeholder="请填写详细地址"
        ></a-input>
      </a-form-item> -->

      <!-- 队友信息 -->
      <a-collapse defaultActiveKey="1" v-if="eventInfo.applyTeam==1">
        <a-collapse-panel
          key="1"
          header="队友信息 (如单人项目，不填)"
          forceRender
        >
          <a-form-item label="队友姓名">
            <a-input v-decorator="['teammateNames']" placeholder=""></a-input>
          </a-form-item>
          <a-form-item label="身份证号码">
            <a-input v-decorator="['teammateIdcards']" placeholder=""></a-input>
          </a-form-item>
          <a-form-item label="年级">
            <j-dict-select-tag
              v-decorator="['teammateGrades']"
              :trigger-change="true"
              dictCode="grade"
              placeholder="请选择年级"
            />
          </a-form-item>
        </a-collapse-panel>
      </a-collapse>

      <a-button type="primary" style="display:block;margin:20px auto;width:200px;" size="large" :loading="confirmLoading" @click="handleOk">{{eventCategory?'修改':'报名'}}</a-button>
    </a-form>
    <EventPay ref="eventPay" @payOk="payOk"/>
    <PhotoModal ref="photoModal" @ok="photoChange"></PhotoModal>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/manage";
import {mixinDevice} from '@/utils/mixin.js'
import moment from "moment";
import pick from "lodash.pick";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import JSearchSelectTag from '@/components/jeecg/JSearchSelectTag'
import JAreaLinkage from "@comp/jeecg/JAreaLinkage";
import JCategorySelect from "@comp/jeecg/JCategorySelect";
import JUpload from '@/components/jeecg/JUpload'
import PhotoModal from "@/components/user/PhotoModal";
import EventPay from "./EventPay"
import { filterMultiDictText } from "@comp/jeecg/JDictSelectUtil";

export default {
  name: "EventApplyModal",
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
    JAreaLinkage,
    JCategorySelect,
    JUpload,
    PhotoModal,
    EventPay,
    JSearchSelectTag
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      model: {},
      eventId: "",
      eventCategory: "",
      eventInfo: {},
      canApplyMulti: true, //是否可以报名多项
      applyConfig:{},
      applyPrice:0, //报名费用
      applyEventInfo: {},
      eventCategory: "",
      validatorRules: {
        photo: {
          rules: [{ required: true, message: "请上传证件照!" }],
        },
        realname: {
          rules: [{ required: true, message: "请输入真实姓名!" }],
        },
        idcard: {
          rules: [
            {
              required: true,
              pattern:
                /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
              message: "请输入正确的身份证号码!",
            },
          ],
        },
        // birthday: {
        //   initialValue: '1999-10-10',
        //   rules: [
        //     { required: true, message: "请输入生日!" },
        //     { validator: this.handleBirthdayCheck },
        //   ],
        //   validateTrigger: ["change", "blur"],
        //   validateFirst: true,
        // },
        grade: {
          rules: [{ required: true, message: "请输入年级!" }],
        },
        schoolClass:{
          rules: [{ required: false, message: "请输入班级!" }],
        },
        email: {
          rules: [{ 
            required: true, 
            pattern:/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: "请输入正确的邮箱地址!" 
          }],
        },
        teacherName: {
          rules: [{ required: false, message: "请输入辅导老师姓名!" }],
        },
        teacherPhone: {
          rules: [
            {
              required: false,
              message: "请输入辅导老师手机号!",
              pattern: /^1[3456789]\d{9}$/,
            },
          ],
        },
        parentName: {
          rules: [{ required: false, message: "请输入监护人姓名!" }],
        },
        parentPhone: {
          rules: [
            {
              required: false,
              message: "请输入监护人手机号!",
              pattern: /^1[3456789]\d{9}$/,
            },
          ],
        },
        sex: {
          initialValue: 1,
          rules: [{ required: true, message: "请选择性别!" }],
        },
        school: {
          rules: [
            { required: true, message: "请填写在读学校!不可写校外机构名" },
          ],
        },
        address: {
          rules: [{ required: true, message: "请选择省市" }],
        },
        addressDetailed: {
          initialValue: '朱泾镇',
          rules: [{ required: true, message: "请填写详细地址" }],
        },
        eventCategory: {
          rules: [{ required: true, message: "请选择报名类别" }],
        },
      },
    };
  },
  created() {},
  methods: {
    // handleBirthdayCheck(rule, value, callback) {
    //   let birthday = this.form.getFieldValue("birthday");

    //   let idcard = this.form.getFieldValue("idcard");
    //   if (birthday === undefined) {
    //     callback(new Error("请选择生日"));
    //   }
    //   birthday = birthday.format("YYYYMMDD");
    //   console.log(birthday);
    //   if (value && !idcard.includes(birthday)) {
    //     callback(new Error("生日和身份证信息不一致"));
    //   }
    //   callback();
    // },
    checkNumber(theObj) {
      var reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(theObj)) {
        return true;
      }
      return false;
    },
    open(eventId, eventCategory) {
      if (!eventId) {
        this.$message.warning("参数错误");
      }
      this.getEventInfo(eventId)
      this.eventId = eventId;
      this.eventCategory = eventCategory
      if (eventCategory) {
        this.canApplyMulti = false;
        this.$nextTick(() => {
          this.form.setFieldsValue({ eventCategory: eventCategory });
        });
        this.getMyApplyInfo(eventCategory);
      }else{
        // this.getEventInfo(eventId)
      }
      this.visible = true;
    },
    getEventInfo(eventId) {
      getAction('/teaching/teachingEvent/queryById', { id: eventId }).then((res) => {
        if (res.success) {
          this.eventInfo = res.result
          this.applyConfig = JSON.parse(this.eventInfo.applyConfig)
        }else{
          this.$message.warning("活动不存在");
        }
      })
    },
    getMyApplyInfo(eventCategory) {
      getAction("/teaching/teachingEventApply/myApplyByEventId", {
        eventId: this.eventId,
        eventCategory: eventCategory,
      }).then((res) => {
        if (res.success) {
          this.applyEventInfo = res.result;
          
          this.$nextTick(() => {
            this.form.setFieldsValue(
              pick(
                this.applyEventInfo,
                "realname",
                "idcard",
                "grade",
                "schoolClass",
                "teacherName",
                "teacherPhone",
                "parentName",
                "parentPhone",
                "sex",
                "school",
                "address",
                "addressDetailed",
                "teammateNames",
                "teammateIdcards",
                "teammateGrades",
                "eventCategory",
                "email",
              )
            );
            // this.form.setFieldsValue({
            //   birthday: moment(this.applyEventInfo.birthday, "YYYY-MM-DD"),
            // });
          });
        }else{

        }
      });
    },
    onEventCategoryChange(value, label, data) {
      this.model.eventCategory = value
      getAction("/teaching/teachingEventCategory/getApplyPrice", {eventId:this.eventId, categoryIds:value}).then(res=>{
        if(res.success){
          this.applyPrice = res.result
        }
      })
      // this.applyPrice = 0
      // for(let i in data){
      //   if(data[i].customValue){
      //     let config = JSON.parse(data[i].customValue)
      //     if(config.baseConfig && config.baseConfig.applyPrice){
      //       console.log(label[i], config.baseConfig.applyPrice);
      //       let price = parseFloat(config.baseConfig.applyPrice) 
      //       this.applyPrice += price
      //     }
      //   }
      // }
    },
    photoChange(key, photoId) {
      putAction("/sys/sysUserModify/modify", { photo: photoId })
        .then((res) => {
          if (res.success) {
            //this.getUserInfo();
            this.$info({
              title: "提示",
              content: "修改证件照将在3个工作日内审核完毕",
              onOk() {},
            });
          } else {
            this.$message.warning(res.message);
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    handleOk() {
      let that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          if (!values.birthday) {
            values.birthday = "";
          } else {
            values.birthday = values.birthday.format("YYYY-MM-DD");
          }
          values.id = this.applyEventInfo.id;
          values.eventId = this.eventId;
          postAction("/teaching/teachingEventApply/apply", values).then((res) => {
            if (res.success) {
              if(that.applyPrice > 0){
                //创建订单
                let orderInfo = res.result
                if(orderInfo){
                  that.$refs.eventPay.open(orderInfo)
                }else{
                  that.$message.success(res.message);
                  //this.$router.push({path: "/user/event"})
                }
                
              }else{
                that.$message.success(res.message);
                //this.$router.push({path: "/user/event"})
                that.handleCancel();
              }
              that.visible = false;
              that.confirmLoading = false;
            } else {
              that.$message.warning(res.message);
              that.confirmLoading = false;
            }
          })
        }
      });
    },
    payOk(){
      this.$router.push({path: "/user/event"})
      this.handleCancel()
    },
    payError(){
      this.confirmLoading = false;
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.form.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 200px;
  height: 280px;
  box-shadow: 0 0 4px #ccc;
  .upload-icon {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;
    &:hover {
      opacity: 1;
    }
    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }
  img,
  .mask {
    width: 100%;
    max-width: 200px;
    height: 100%;
    overflow: hidden;
  }
}

.photo-example {
  text-align: center;
  img {
    margin-top: 10px;
  }
  .tips {
    position: relative;
    top: -200px;
    color: white;
    font-weight: 600;
    font-size: 30px;
    line-height: 0;
  }
}
</style>